import styled from 'styled-components';

// Floats in the bottom-right corner on every page, out of the main flow.
export const LanguageSelectBox = styled.div`
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 180px;
  z-index: 10;
`;
